<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  count: { type: Number, required: true },
  loading: { type: Boolean, default: false },
  options: { type: Array, default: () => [] },
  rows: { type: Array, default: () => [] },
});

const emit = defineEmits(['changeCount', 'updateRow']);
const { t } = useI18n();
</script>

<template>
  <LaisField :label="t('REAL_ESTATE_FINANCE.PAYERS_FORM.QUANTITY')" required>
    <select
      :value="count"
      :disabled="!options.length || loading"
      class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:bg-lais-bg-soft"
      @change="emit('changeCount', $event.target.value)"
    >
      <option v-for="value in options.length" :key="value" :value="value">
        {{ value }}
      </option>
    </select>
  </LaisField>

  <p
    v-if="!options.length"
    class="rounded-lais bg-lais-bg-soft p-3 text-sm text-lais-text-muted"
  >
    {{ t('REAL_ESTATE_FINANCE.PAYERS_FORM.NO_OPTIONS') }}
  </p>

  <div v-else class="grid gap-4">
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="grid gap-4 rounded-lais border border-lais-border-soft p-3 sm:grid-cols-2"
    >
      <LaisField :label="t('REAL_ESTATE_FINANCE.PAYERS_FORM.PARTY')" required>
        <select
          :value="row.property_transaction_party_id"
          :disabled="loading"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:bg-lais-bg-soft"
          @change="
            emit('updateRow', {
              index,
              field: 'property_transaction_party_id',
              value: $event.target.value,
            })
          "
        >
          <option value="">
            {{ t('REAL_ESTATE_FINANCE.PAYERS_FORM.SELECT') }}
          </option>
          <option v-for="option in options" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </LaisField>
      <LaisField :label="t('REAL_ESTATE_FINANCE.PAYERS_FORM.AMOUNT')" required>
        <input
          :value="row.valor_pagamento"
          inputmode="decimal"
          :disabled="loading"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm disabled:bg-lais-bg-soft"
          @input="
            emit('updateRow', {
              index,
              field: 'valor_pagamento',
              value: $event.target.value,
            })
          "
        />
      </LaisField>
    </div>
  </div>
</template>
